import { defineStore } from "pinia";
import { getCookieJWT, resetCookies } from "@/utilities/cookies";
import { AuthState, User } from "@/types/auth-types";

import { attempt } from "@/utilities/attempt";

export const useAuth = defineStore("auth", {
    state: (): AuthState => ({
        user: {} as User,
        authenticated: false
    }),
    actions: {
        async login() {
            attempt(async () => {
                window.location.href = "https://zoomphone-ecall.dsc.umich.edu/api/login/shibboleth";
            });
        },
        logout() {
            attempt(async () => {
                resetCookies();
            });
        },
        async storeUserCredentials(userResp: string) {
            this.user = JSON.parse(userResp);
            this.authenticated = true;
        },
        async checkServerAuthStatus() {
            attempt(async () => {
                const response = await fetch("https://zoomphone-ecall.dsc.umich.edu/api/auth-check", {
                    headers: {
                        'Authorization': getCookieJWT()
                    }
                });
                return response.ok 
                    ? await this.storeUserCredentials(await response.json())
                    : (
                        this.user = {} as User,
                        this.authenticated = false
                    ) 
            });
        }
    },
    getters: {
        getUser: (state) => state.user,
        getAuthStatus: (state) => state.authenticated
    }
})